<div class="row">
  <div class="col-12">
    <div class="d-flex justify-content-between">
      <h1 class="h4">
        {{title}}
      </h1>
      @if (actionButtonTitle) {
        <div class="flex">
          <button class="btn btn-success" (click)="actionButtonClicked.emit()">{{actionButtonTitle}}</button>
        </div>
      }
    </div>
  </div>
</div>
